export const SoundServices = {
  srcNotification: '../../../assets/sounds/new-notification.mp3',
  srcTurnOn: '../../../assets/sounds/happy-pop.mp3',

  isTurnOn: () => {
    const a = localStorage.getItem('sound');
    if (a === 'true') {
      return true;
    }
    return false;
  },

  turnOnSound: () => {
    localStorage.setItem('sound', 'true');
  },

  turnOffSound: () => {
    localStorage.setItem('sound', 'false');
  },
};
